const AUTH_PATHS = ['/login', '/signup', '/resetpassword', '/auth/'];

export function resolvePostAuthReturnUrl(returnUrl, search) {
	if (returnUrl && returnUrl.startsWith('/') && !AUTH_PATHS.some(p => returnUrl.startsWith(p))) {
		return returnUrl;
	}
	try {
		const params = new URLSearchParams(search);
		const paramUrl = params.get('returnUrl') || params.get('return_url');
		if (paramUrl && paramUrl.startsWith('/') && !AUTH_PATHS.some(p => paramUrl.startsWith(p))) {
			return paramUrl;
		}
	} catch (e) {
		// invalid search string
	}
	return '/';
}

export function shouldRedirectAfterAuth(nextUrl, pathname) {
	if (!nextUrl) return false;
	if (AUTH_PATHS.some(p => nextUrl.startsWith(p))) return false;
	return nextUrl !== pathname;
}
